export enum YesNoEnum {
  Yes = 'yes',
  No = 'no',
}
